import { createRef } from 'react'
import { findDOMNode } from 'react-dom'
import { clamp } from '../../utils/math'
import ElementPan from './element_pan'
import AbstractNav from './abstract_nav'

export default class Nav extends AbstractNav {
  static propTypes = Object.assign({}, AbstractNav.propTypes, {
    // nothing
  })

  static defaultProps = Object.assign({}, AbstractNav.defaultProps, {
    // nothing
  })

  constructor(props) {
    super(props)
    // Note: already has some state defined in abstract class
    this.$navRef = createRef()
    this.$navItemsRef = createRef()
  }

  calculateCanScrollValues() {
    const element = findDOMNode(this.$navItemsRef.current)
    const { scrollWidth, offsetWidth, scrollLeft } = element
    return this.calcScroll(scrollWidth, offsetWidth, scrollLeft)
  }

  scrollTo(offset) {
    const navElement = findDOMNode(this.$navRef.current)
    const element = findDOMNode(this.$navItemsRef.current)
    const { scrollLeft } = element
    offset = clamp(offset, 0, element.scrollWidth - navElement.offsetWidth)
    this.animateTo(offset)
  }

  scrollLeft() {
    const navElement = findDOMNode(this.$navRef.current)
    const element = findDOMNode(this.$navItemsRef.current)
    const offset = element.scrollLeft - navElement.offsetWidth
    this.scrollTo(offset)
  }

  scrollRight() {
    const navElement = findDOMNode(this.$navRef.current)
    const element = findDOMNode(this.$navItemsRef.current)
    const offset = element.scrollLeft + navElement.offsetWidth
    this.scrollTo(offset)
  }

  render() {
    const { navClass } = this.props
    const { offset } = this.state

    const navItems = this.getNavItemsContent()
    const scrollers = this.getScrollersContent()

    return (
      <div className="tabbed-nav__navigation">
        <nav key="nav" className={navClass} ref={this.$navRef}>
          <ElementPan
            tag="ul"
            className="tabbed-nav__list"
            ref={this.$navItemsRef}
            scrollLeft={offset}
            onScroll={this.throttledHandleScroll}
          >
            {navItems}
          </ElementPan>
        </nav>
        {scrollers}
      </div>
    )
  }
}
